//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import md5 from 'md5';
import remPsw from '../components/rem-psw';

export default {
    components: { remPsw },
    props: [],
    data() {
        return {
            form: {
                loginname: '',
                pwd: '',
            },
        };
    },
    methods: {
        onSubmit() {
            if (!this.form.loginname) {
                return ShowMsg.call(this, '请填写账号');
            } else if (!this.form.pwd) {
                return ShowMsg.call(this, '请填写密码');
            }

            let sendForm = {
                loginname: this.form.loginname,
                pwd: md5(this.form.pwd),
            };

            this.$post('/bhtong/admin/login.json', sendForm, (data, res) => {
                ShowMsg.call(this, '登录成功', 'success');

                data.user.avatar = data.avatar || '';
                data.user.maxnum = data.maxnum || '';
                data.user.biglogo = data.biglogo || '';
                data.user.smalllogo = data.smalllogo || '';

                this.$store.commit('setLoginUserInfo', data);

                // window.location.replace(res.url);
                // this.$router.replace(res.url);
                this.$router.replace('/office/guarantee/list');
            });
        },
        fgtPwd() {
            ShowMsgBox.call(this, '请联系单位管理员重置密码');
        },
    },
    mounted: function () {},
};
